import { NgModule } from '@angular/core';
import { SpinnerModule } from './spinner/spinner.module';
import { PromptModule } from './prompt/prompt.module';

@NgModule({
  imports:      [ SpinnerModule,
                  PromptModule ],
  declarations: []
})
export class ServicesModule {
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/services/services.module.ts